import { render } from "./NestedQuestion.vue?vue&type=template&id=cc3b4ff8&scoped=true"
import script from "./NestedQuestion.vue?vue&type=script&lang=js"
export * from "./NestedQuestion.vue?vue&type=script&lang=js"

import "./NestedQuestion.vue?vue&type=style&index=0&id=cc3b4ff8&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3b4ff8"]])

export default __exports__